window.browserResize = {

    enableScroll: (viewport, content) => {
        let y = 0, viewportY = 0, dy = 0;
        // Add the scroll behaviour on pointer down
        content.onpointerdown = ev => {
            // Clear the scroll behaviour on pointer up anywhere on the window
            window.onpointerup = ev => {
                content.onpointermove = null;
                // content.releasePointerCapture(ev.pointerId);
            };
            // Apply scroll changes to the viewport when the pointer moves
            content.onpointermove = ev => {
                dy = ev.clientY - y;
                // console.log("Pointer move DY: " + dy + " ScrollTop: " + viewport.scrollTop);
                viewport.scrollTop = viewportY - dy;
            };

            viewportY = viewport.scrollTop;
            y = ev.clientY;
            // content.setPointerCapture(ev.pointerId);
        };
    },
    initialise: dotnetHelper => {
        window.browserResize.refresh(dotnetHelper);
    },
    resizeListener: function (dotnetHelper) {
        window.addEventListener('resize', () => {
            this.refresh(dotnetHelper);
        });
    },

    refresh: function (dotnetHelper) {
        // console.log('refresh');
        let browserHeight = window.innerHeight;
        let browserWidth = window.innerWidth;
        dotnetHelper?.invokeMethodAsync('SetBrowserDimensions', browserWidth, browserHeight).then(() => {
            // success, do nothing
        }).catch(error => {
            console.log("Error during browser resize: " + error);
        });
    },

    applyTransform: function (target, scale, translateX, translateY) {
        // console.log("Bounding Width: " + target.scrollWidth);
        // console.log("Bounding Height: " + target.scrollHeight);

        function step(timestamp) {
            // console.log('[RequestAnimationFrame] [ApplyTransform] scale: ' + scale + ' tx: ' + translateX + ' ty: ' + translateY + ' target: ' + target);
            target.style.transform = 'translateX(' + translateX + ')' + ' translateY(' + translateY + ')' + ' translateZ(0)' + ' scale(' + scale + ')';
        }

        window.requestAnimationFrame(step);
    },
    applyScale: function (target, scale) {
        // console.log('[ApplyScale] ' + scale + ' target: ' + target);
        target.style.transform = 'scale(' + scale + ')';
    },
    getWidth: function (target) {
        if (!target) return 0;
        let offsetWidth = target.getBoundingClientRect().width;
        // console.log('GetWidth: ' + offsetWidth + ' ClientWidth: ' + target.clientWidth)
        return offsetWidth || 0;
    },
    getHeight: function (target) {
        if (!target) return 0;
        let rect = target.getBoundingClientRect();
        let offsetHeight = rect.height;
        // console.log('GetHeight: ' + offsetHeight + ' ClientHeight: ' + target.clientHeight)
        return offsetHeight || 0;
    },
    setWidth: function (target, width) {
        target.style.width = width;
    },
    setHeight: function (target, height) {
        target.style.height = height;
    }
}